import { inject, observer } from "mobx-react";
import React from "react";
import { ProposalStore } from "../../../stores/proposalStore";
import Header from "../../sharedComponents/header/header";
import TextInput from "../../sharedComponents/textInput/textInput";

interface IssuePlaceProps {
    proposalStore?: ProposalStore;
}

interface IssuePlaceState {
    issuePlace: string;
}

@inject("proposalStore")
@observer
export default class IssuePlace extends React.Component<IssuePlaceProps, IssuePlaceState> {
    constructor(props: any) {
        super(props);

        this.state = {
            issuePlace: this.props.proposalStore!.issuePlace.value
        };
    }

    public componentDidMount() {
        this.setIssuePlace();
    }

    public componentDidUpdate(prevProps: Readonly<IssuePlaceProps>, prevState: Readonly<IssuePlaceState>, snapshot?: any) {
        this.setIssuePlace();
    }

    public render() {
        return (
            <div className="section issue-place">
                <Header type="medium" mainHeader="Miejsce wystawienia polisy" />
                <div className="field-container">
                    <div className="label">Miejsce wystawienia polisy</div>
                    <TextInput
                        disabled={this.props.proposalStore!.distancePolicy.value ?? false}
                        validatedValue={this.props.proposalStore!.issuePlace}
                        onChange={(value) => {
                            this.setState({ issuePlace: value });
                        }}
                    />
                </div>
            </div>
        );
    }

    public setIssuePlace() {
        const distancePolicy = this.props.proposalStore!.distancePolicy.value;
        if (distancePolicy) {
            this.props.proposalStore!.setIssuePlace("WARSZAWA");
        } else {
            this.props.proposalStore!.setIssuePlace(this.state.issuePlace);
        }
    }
}
